import util from '@bmp-vue/core/api/util'

const controller = 'Clients'
export default Object.assign({}, util.GetCrud(controller, null), {
  PostCopyClient: function (dto) {
    return util.Axios.Post(`${controller}/${dto.clientId}/clone`, dto)
  },
  PostClientSecrets: function (dto) {
    return util.Axios.Post(`${controller}/${dto.clientId}/secrets`, dto)
  },
  PostClientProperties: function (dto) {
    return util.Axios.Post(`${controller}/${dto.clientId}/properties`, dto)
  },
  PostClientClaims: function (dto) {
    return util.Axios.Post(`${controller}/${dto.clientId}/claims`, dto)
  },
  DeleteClientsSecrets: function (dto) {
    return util.Axios.Delete(`${controller}`, `${dto.clientId}/secrets?value=${encodeURIComponent(dto.value)}&type=${dto.type}`)
  },
  GetGrandTypes: function () {
    return new Promise((resolve, reject) => {
      const array = [
        { text: 'Empty', value: 0 },
        { text: 'Web App - Server Side (MVC)', value: 1 },
        { text: 'Web App - Server Side (MVC)', value: 2 },
        { text: 'SPA - Single Page Application (e.g Angular, Blazor)', value: 3 },
        { text: 'Native Application - Mobile/Desktop', value: 4 },
        { text: 'Server', value: 5 },
        { text: 'Devices - TVs, gaming consoles, printers, cash registers, audio applicances etc', value: 6 }
      ]
      resolve(array)
    })
  },
  GetAccessTokenType: function () {
    return new Promise((resolve, reject) => {
      const array = [
        { text: 'Jwt', value: 0 },
        { text: 'Reference', value: 1 }
      ]
      resolve(array)
    })
  },
  GetRefreshTokenUsage: function () {
    return new Promise((resolve, reject) => {
      const array = [
        { text: 'One Time Only', value: 0 },
        { text: 'ReUse', value: 1 }
      ]
      resolve(array)
    })
  },
  GetRefreshTokenExpiration: function () {
    return new Promise((resolve, reject) => {
      const array = [
        { text: 'Sliding', value: 0 },
        { text: 'Absolute', value: 1 }
      ]
      resolve(array)
    })
  }
})
